import React from 'react'
import { useSelector } from 'react-redux'
import AdminDashboard from './AdminDashboard'
import MetaClinicDashboard from '../../../Dashboard/meta-clinic-dashboard'
import CoreEnums from '../../../../core/utils/enums'

const DashboardWrapper = () => {
  const authState = useSelector((state) => state.auth)
  const userRole = authState?.agiliteUser?.extraData?.role?.type

  // Show AdminDashboard for admin users, MetaClinicDashboard for medical professionals
  if (userRole === CoreEnums.userRoles.ADMIN) {
    return <AdminDashboard />
  } else if (userRole === CoreEnums.userRoles.MEDICAL_PROFESSIONAL) {
    return <MetaClinicDashboard />
  } else {
    // Default to AdminDashboard for other roles (like reception)
    return <MetaClinicDashboard />
  }
}

export default DashboardWrapper
